import Vue from 'vue';
import axios from "axios";
import store from '@/store';
import domain from './domain';

// Listando apostas para encerramento
const listBetsCashout = async (status) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$axios
      .post(
        "/player/online/betsOnline/listBetsCashout",
        Vue.prototype.$formdata({
          status: status,
        })
      )
      .then((resp) => {
        resolve(resp.data.dados.apostas);
      })
      .catch((error) => {
        reject(error);
      });
  })
};

// Recuperando valores de encerramento e tratandos as apostas
const getValuetoCashoutByBets = async (bets) => {

  // Formatando o array de bets para o Body
  const arryBets = bets.map((item) => {
    return `${item.id}`;
  });
  // Formatando o body
  const body = JSON.stringify({
    bets: arryBets,
  });

  // endpoint
  const endpoint = domain() === "sys"
    ? "https://829jrp8i70.execute-api.us-east-2.amazonaws.com/pro/getValuetoCashoutByBets" // dev
    : "https://829jrp8i70.execute-api.us-east-2.amazonaws.com/pro/getValuetoCashoutByBets"; // prod

  // Headers
  const token = store.state.logged.token;
  const headers = {
    "Content-Type": "application/json",
    "Application-Authorization": token,
  };

  // Request
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint, body, { headers })
      .then((resp) => {
        // response
        let data = resp.data;

        // Tratando as Apostas
        const handlerBets = bets.map((bet) => {
          let cashOutItem = {};

          data.find((cashOut) => {
            if (cashOut.id_aposta == bet.id) {
              cashOutItem = cashOut;
            }
          });

          // Options
          const CANCEL_BET_FACTOR = 0.75;
          const maxPrice = store.state.operators.max_prize; // Max Premio Operador

          if (
            cashOutItem &&
            Number(cashOutItem.valor_cancel_bet) >=
            Number(bet.amount) * CANCEL_BET_FACTOR &&
            Number(cashOutItem.valor_cancel_bet) < Number(maxPrice)
          ) {
            bet.cashOutValue = cashOutItem.valor_cancel_bet;
          } else {
            bet.cashOutValue = "";
          }
          if (
            cashOutItem.result_bet == "0" ||
            cashOutItem.result_bet == "1"
          ) {
            bet.result_bet = cashOutItem.result_bet;
          }
          return bet;
        });
        // Retornando as apostas tratadas
        resolve(handlerBets);
      })
      .catch((error) => {
        reject(error);
      });
  });

};

export {
  listBetsCashout,
  getValuetoCashoutByBets,
}